import Vue from 'vue'

import errorHandler from '@/utils/errorHandler'
import { objectToForm } from '@/utils'

function transformer({ file }) {
  return objectToForm({
    file
  })
}

const keysTranslation = {
  photo: 'Foto',
}
const ignoredKeyNames = ['photo']

export default (payload) => {
  const { supplyId, ...image} = payload
	const transformedData = transformer(image)
	const config = { headers: {'Content-Type': 'multipart/form-data' }}

  const request = Vue.$http.post(`catalogs/services/supplies/pictograms/${supplyId}/`, transformedData, config)
  
  return errorHandler(request, {keysTranslation, ignoredKeyNames})
}


// WEBPACK FOOTER //
// ./src/services/catalog/uploadPictograms.js